import { Component, OnInit, HostListener } from "@angular/core";
import { SharedService } from "../../services/shared.service";
import { TokenService } from "../../../core/tokenManagement/token.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-page-layout",
  templateUrl: "./page-layout.component.html",
  styleUrls: ["./page-layout.component.css"],
})
export class PageLayoutComponent implements OnInit {
  userLocalDetails: any;
  sideNavStatus: boolean = true;

  constructor(private tokenservice: TokenService) {}

  ngOnInit() {
    this.getLocalDetails();
    if (window.innerWidth <= 800) {
      this.sideNavStatus = false;
    }
  }

  listenToNavStatus(event) {
    this.sideNavStatus = event;
    // if (event == true && window.innerWidth < 700) {
    //   document.getElementById("page-content").style.opacity = "0.2";
    // } else {
    //   document.getElementById("page-content").style.opacity = "1";
    // }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    if (event.target.innerWidth > 800) {
      this.sideNavStatus = true;
    } else {
      this.sideNavStatus = false;
    }
  }

  getLocalDetails() {
    this.userLocalDetails = this.tokenservice.getProfileDetials();
  }

  closeNav() {
    if (window.innerWidth < 801) {
      this.sideNavStatus = false;
    }
  }
}
